export default __webpack_public_path__ + "static/4i-2956e2ededac7cd169ec6744e012a9fc.woff";